import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import Message from '../../config/message_v2.js';
import Lib from 'utils/Lib.js'

export default {
  ValidateFormUpdate(form){
    if(!form.assetAlias){
      toast.warning(Message.ERROR.EMPTY.ASSET)
      return false
    } else if (!form.service) {
      toast.warning(Message.ERROR.EMPTY.MAINTENANCE)
      return false
    } else if (!form.scheduledStart) {
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_START)
      return false
    } else if (!form.scheduledEnd) {
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_END)
      return false
    } else if (!form.description) {
      toast.warning(Message.ERROR.EMPTY.DESCRIPTION)
      return false
    } else if (form.isRepeating === 'Yes' && !Lib.toInt(form.repeatPeriod)) {
      toast.warning(Message.ERROR.EMPTY.REPEAT_PERIOD)
      return false
    } else if (form.isReminder === 'Yes' && !form.count) {
      toast.warning(Message.ERROR.EMPTY.REMINDER_LIST)
      return false
    } 
    return true
  },

  ValidateForm(form){
    if(!form.asset){
      toast.warning(Message.ERROR.EMPTY.ASSET)
      return false
    } else if (!form.service) {
      toast.warning(Message.ERROR.EMPTY.MAINTENANCE)
      return false
    } else if (!form.scheduledStart) {
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_START)
      return false
    } else if (!form.scheduledEnd) {
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_END)
      return false
    } else if (!form.description) {
      toast.warning(Message.ERROR.EMPTY.DESCRIPTION)
      return false
    } else if (form.isRepeating === 'Yes' && !Lib.toInt(form.repeatPeriod)) {
      toast.warning(Message.ERROR.EMPTY.REPEAT_PERIOD)
      return false
    } else if (form.isReminder === 'Yes' && form.rowReminder.length === 0) {
      toast.warning(Message.ERROR.EMPTY.REMINDER_LIST)
      return false
    } 
    return true
  },

  ValidateFormRequestMaintenance(form, message) {
    if(!form.Asset){
      toast.warning(message.ERROR.EMPTY.ASSET)
      return false
    } else if (!form.Service) {
      toast.warning(message.ERROR.EMPTY.MAINTENANCE)
      return false
    } else if (!form.Description){
      toast.warning(message.ERROR.EMPTY.DESCRIPTION)
      return false
    } 
    return true
  },

  validateFormReport(form, message) {
    if(!form.Asset){
      toast.warning(message.ERROR.EMPTY.ASSET)
      return false
    } else if (!form.Type) {
      toast.warning(message.ERROR.EMPTY.REPORT_TYPE)
      return false
    } else if (!form.Description){
      toast.warning(message.ERROR.EMPTY.DESCRIPTION)
      return false
    } 
    return true
  },

  validateFormReminder(form) {
    if(form.method === 'email') {
      if(!form.email){
        toast.warning(Message.ERROR.EMPTY.EMAIL)
        return false
      } else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 

    } else if(form.method === 'mobile') {
      if(!form.mobile){
        toast.warning(Message.ERROR.EMPTY.PHONE_NUMBER)
        return false
      } else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 

    } else {
      if(!form.email){
        toast.warning(Message.ERROR.EMPTY.EMAIL)
        return false
      } else if(!form.mobile){
        toast.warning(Message.ERROR.EMPTY.PHONE_NUMBER)
        return false
      }  
      else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 
    }
    return true
  },

  ValidateFormStartWork(form) {
    if(!form.Contractor){
      toast.warning(Message.ERROR.EMPTY.CONTRACTOR)
      return false
    }
    return true
  },

  ValidateFormFinishWork(form) {
    if(form.Amount === "" || form.Amount === null){
      toast.warning(Message.ERROR.EMPTY.AMOUNT)
      return false
    }else if(form.Amount < 0){
      toast.warning(Message.ERROR.INVALID.AMOUNT)
      return false
    }
    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/form.js